import React from 'react';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';

const WaterPollutionBigSource = () => {
  document.title = "Усны бохирдлын томоохон эх үүсвэр";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Ус бохирдлын эх үүсвэр" breadcrumbItem="Усны бохирдлын томоохон эх үүсвэр" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <CardTitle tag="h5" className="mb-0 flex-grow-1"> Усны бохирдлын томоохон эх үүсвэр</CardTitle>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default WaterPollutionBigSource;